/**
 * QuantityStepper : sélecteur de quantité (− / +) avec raccourcis (6 · 12 · 24).
 * Réutilisé par la vérification d'entrée et le mode rafale.
 */
import { Minus, Plus } from 'lucide-react';
import { QUANTITY_SHORTCUTS } from '../../constants';

export function QuantityStepper({ value, onChange, min = 0, max, shortcuts = true, size = 'md', testId = 'qty' }) {
  const set = (v) => onChange(Math.max(min, max !== undefined ? Math.min(max, v) : v));
  const lg = size === 'lg';
  const btn = lg ? 'w-14 h-14' : 'w-10 h-10';
  const num = lg ? 'w-20 text-5xl' : 'w-14 text-xl';
  return (
    <div data-testid={testId}>
      <div className="inline-flex items-center border border-hair rounded-md overflow-hidden">
        <button data-testid={`${testId}-minus`} onClick={() => set(value - 1)} className={`${btn} flex items-center justify-center hover:bg-surface`}>
          <Minus className={lg ? 'w-5 h-5' : 'w-4 h-4'} strokeWidth={1.6} />
        </button>
        <span className={`${num} text-center nums`} data-testid={`${testId}-value`}>{value}</span>
        <button data-testid={`${testId}-plus`} onClick={() => set(value + 1)} className={`${btn} flex items-center justify-center hover:bg-surface`}>
          <Plus className={lg ? 'w-5 h-5' : 'w-4 h-4'} strokeWidth={1.6} />
        </button>
      </div>
      {shortcuts && (
        <div className="flex gap-1.5 mt-2">
          {QUANTITY_SHORTCUTS.map((n) => (
            <button key={n} data-testid={`${testId}-shortcut-${n}`} onClick={() => set(n)}
              className={`px-3 h-8 rounded-md border text-[13px] ${value === n ? 'vd-tag-fill border-transparent' : 'border-hair hover:bg-surface'}`}>
              {n}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
